import Swal from 'sweetalert2';

export const showToast = (icon, title) => {
  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  };

  const selectedColor = colors[icon] || colors.info;

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    width: '320px',
    didOpen: (toast) => {
      toast.style.zIndex = '999999';
      const progressBar = toast.querySelector('.swal2-timer-progress-bar');
      if (progressBar) progressBar.style.backgroundColor = selectedColor;
    },
    customClass: {
      popup: 'radius-12 border-0 shadow-lg',
      title: 'fs-14 fw-semibold mb-0'
    }
  });

  Toast.fire({
    icon: icon,
    iconColor: selectedColor,
    title: title
  });
};

/**
 * Global Delete Confirmation Helper
 * @param {string} title - The name of the item being deleted
 * @param {function} onConfirm - The function to run if the user clicks 'Delete'
 */
export const confirmDelete = (itemName, onConfirm) => {
  Swal.fire({
    title: 'Are you sure?',
    text: `You are about to delete "${itemName}". This action cannot be undone.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444', // Danger Red
    cancelButtonColor: '#64748b',  // Muted Slate
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    width: '400px',
    customClass: {
      popup: 'radius-16 border-0 shadow-lg',
      title: 'fs-5 fw-bold',
      confirmButton: 'btn btn-danger px-4',
      cancelButton: 'btn btn-secondary px-4'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};